import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const UserReports = React.lazy(() => import("@kaltura/mediaspace-features-user-reports"));

export const render = getDsLayoutComponentRenderer(UserReports);
